module.exports = __webpack_public_path__ + "components/weather-icon/static/dayclear-3ef3699a00bb17bf50e9420d7a01b1ce.png";